import React, { Component } from "react";
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import axios from 'axios';
import { Link } from "react-router-dom";
import { Breadcrumb, Card } from "antd";

import CircularProgress from "components/CircularProgress";
import PageHeader from "components/PageHeader";
import Auxiliary from "util/auxiliary";

class CookiePolicy extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            cookieData: {},
            errorMessage: null
        }
    }
    componentDidMount() {
        this.setState({
            isLoading: true
        }, () => {
            const AuthStr = 'Bearer '.concat(process.env.REACT_APP_API_TOKEN);
            const INSTANCE = axios.create({
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': AuthStr
                }
            });

            let inputJSON = JSON.stringify({
                type: 'Cookie'
            });

            INSTANCE.post("legal/get-legal", inputJSON)
                .then(response => {
                    if (response.data.messageId === 200) {
                        this.setState({ isLoading: false, cookieData: response.data });
                    } else {
                        this.setState({ isLoading: false, errorMessage: response.data.message });
                    }
                })
                .catch(error => {
                    this.setState({ isLoading: false, errorMessage: error.message });
                });
        })
    }

    render() {
        const { isLoading, cookieData } = this.state;
        return (
            <Auxiliary>
                <Row className="margin-bottom">
                    <Col>
                        <Breadcrumb>
                            <Breadcrumb.Item>
                                <Link to="/home/dashboard" className="gx-link">Dashboard</Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>Cookie Policy</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                </Row>
                <PageHeader title="Cookie Policy" navigateTo="/legal/add-cookie-policy" linkName="Add/Edit"/>
                {isLoading ?
                    <div className="gx-loader-view">
                        <CircularProgress />
                    </div> :
                    <Card>
                        <Row>
                            <Col md="12">
                                {
                                    cookieData.data ?
                                        <div dangerouslySetInnerHTML={{ __html: cookieData.data.description }} />
                                        : null
                                }
                            </Col>
                        </Row>
                    </Card>
                }
            </Auxiliary >
        );
    }
}

function mapStateToProps(state) {
    return {
        auth: state.auth
    }
}


export default connect(mapStateToProps, null)(CookiePolicy);
